import axios, { AxiosRequestConfig } from "axios";

import { removeSession } from "@/context";
import { getApiBaseUrl } from "./getApiBaseUrl";

interface RequestConfig extends AxiosRequestConfig {
  includeReferrerUrlHeader?: boolean;
}

/**
 * Performs an API request.
 * @param options: The request options.
 * @param authToken: The optional authentication token.
 */
export async function request<T>(options: RequestConfig, authToken?: string): Promise<T> {
  const baseUrl = getApiBaseUrl();

  const client = axios.create({
    baseURL: baseUrl,
    headers: {
      "X-Referrer-Url": window.location.href,
    },
  });

  if (options?.includeReferrerUrlHeader === false) {
    delete client.defaults.headers["X-Referrer-Url"];
  }

  if (authToken) {
    client.defaults.headers.common = {
      Authorization: `Bearer ${authToken}`,
    };
  }

  try {
    const result = await client(options);
    return result.data;
  } catch (err) {
    // Catch unauthorized calls and ensure user is logged out
    if (axios.isAxiosError(err) && err.response?.status === 401) {
      removeSession();
    }

    throw err;
  }
}
